import type { SessionUser } from '@/contexts/auth-context';
import { useAuthContext } from '@/contexts/auth-context';

export const useUser = (): SessionUser => {
  const { user } = useAuthContext();

  if (!user) {
    throw new Error('No session found');
  }

  return user;
};
